export const tableConfig = [
  {
    name: "name",
    label: " ",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
    },
  },
  {
    name: "lastMonth",
    label: "Last Month",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "thisMonth",
    label: "This Month",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "growth",
    label: "Growth",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "proyeksi",
    label: "Proyeksi",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
];

export const CONSTANT_NAME = {
  unitEntri: "Unit Entri",
  unitNonServis: "Unit Non Servis",
  unitServis: "Unit Servis",
  unitNonKpb: "Unit Non KPB",
  kpb1: "KPB 1",
  kpb2: "KPB 2",
  kpb3: "KPB 3",
  kpb4: "KPB 4",
};
